module.exports = __webpack_public_path__ + "static/media/Crop 2.95b429ae.svg";